import decode from 'jwt-decode';
/**
 * Get a property from the access token.
 */

var getTokenProperty = function getTokenProperty(accessToken, key) {
  var prop;

  try {
    var _decode;

    prop = (_decode = decode(accessToken.replace(/^Bearer\s*/, ''))) === null || _decode === void 0 ? void 0 : _decode[key];
  } catch (err) {// Failed to decode token; return undefined
  }

  return prop;
};
/**
 * Get the user GUID from the access token.
 */


export var getUserGuid = function getUserGuid(accessToken) {
  return getTokenProperty(accessToken, 'sub');
};
/**
 * Get the user vanity ID from the access token.
 */

export var getUserVanityId = function getUserVanityId(accessToken) {
  return getTokenProperty(accessToken, 'vanity_id');
};
/**
 * Get the login method from the access token.
 */

export var getUserLoginMethod = function getUserLoginMethod(accessToken) {
  return getTokenProperty(accessToken, 'idp');
};
/**
 * Get the user role from the access token.
 */

export var getUserRole = function getUserRole(accessToken) {
  return getTokenProperty(accessToken, 'role');
};